import React from 'react'
import styles from './EditableImageBox.module.sass'
import WImage from '../WImage/WImage'

interface Props {
  conf: any
  confTablet?: any
  confMobile?: any
  editMode?: boolean
  className?: string
  children?: React.ReactNode
}

const EditableImageBox = (props: Props) => {
  const {
    conf = {},
    confTablet = undefined,
    confMobile = undefined,
    editMode = false,
    className = '',
    children = undefined,
  } = props

  return (
    editMode || (
      <div className={className}>
        <WImage
          {...conf}
          className={`${styles.image} ${
            !!confTablet || !!confMobile ? styles['image--desktop'] : ''
          } ${confMobile && !confTablet ? styles['image--tablet'] : ''}${conf.className || ''}`}
        />
        {confTablet && (
          <WImage
            {...{ ...(conf || {}), ...(confTablet || {}), src: confTablet.src || conf.src }}
            className={`${styles.image} ${styles['image--tablet']} ${
              !confMobile ? styles['image--mobile'] : ''
            } ${conf.className || ''}`}
          />
        )}
        {confMobile && (
          <WImage
            {...{
              ...(conf || {}),
              ...(confTablet || {}),
              ...(confMobile || {}),
              src: confMobile.src || confTablet.src || conf.src,
            }}
            className={`${styles.image} ${styles['image--mobile']} ${conf.className || ''}`}
          />
        )}
        {children}
      </div>
    )
  )
}

export default EditableImageBox
